import { IconProps } from "./types";
import React from "react";

export const FilterIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 14 14"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M1.1665 3.5H12.8332V4.375H1.1665L1.1665 3.5ZM2.9165 6.41667H11.0832V7.29167H2.9165V6.41667ZM5.24984 9.04167H8.74984V9.91667H5.24984V9.04167Z"
      fill={fill}
    />
  </svg>
);
